var map = {
	"./woodstock_kitchens_1.jpg": 8615,
	"./woodstock_kitchens_10.jpg": 4455,
	"./woodstock_kitchens_11.jpg": 9994,
	"./woodstock_kitchens_12.jpg": 2597,
	"./woodstock_kitchens_13.jpg": 232,
	"./woodstock_kitchens_14.jpg": 2907,
	"./woodstock_kitchens_15.jpg": 1774,
	"./woodstock_kitchens_16.jpg": 5481,
	"./woodstock_kitchens_17.jpg": 108,
	"./woodstock_kitchens_18.jpg": 1055,
	"./woodstock_kitchens_19.jpg": 3122,
	"./woodstock_kitchens_2.jpg": 9944,
	"./woodstock_kitchens_3.jpg": 7557,
	"./woodstock_kitchens_4.jpg": 4670,
	"./woodstock_kitchens_5.jpg": 4827,
	"./woodstock_kitchens_6.jpg": 8380,
	"./woodstock_kitchens_7.jpg": 6169,
	"./woodstock_kitchens_8.jpg": 3458,
	"./woodstock_kitchens_9.jpg": 9839
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5887;